module.exports = __webpack_public_path__ + "img/conocenos4.e3e543ed.webp";